export default "__VITE_ASSET__BD$lsCiA__"